export default "__VITE_ASSET__2833ab0c__"